// tslint:disable:max-line-length
import React from 'react';

export const ProductOTH = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C4 0.89543 4.89543 0 6 0H10C11.1046 0 12 0.895431 12 2C13.1046 2 14 2.89543 14 4V6C14 7.10457 13.1046 8 12 8H8C6.89543 8 6 7.10457 6 6C4.89543 6 4 5.10457 4 4V2ZM8 7C7.44772 7 7 6.55228 7 6H10C11.1046 6 12 5.10457 12 4V3C12.5523 3 13 3.44772 13 4V6C13 6.55228 12.5523 7 12 7H8Z"
      />
      <path d="M5 8C5 9.10457 4.10457 10 3 10C1.89543 10 1 9.10457 1 8C1 6.89543 1.89543 6 3 6C4.10457 6 5 6.89543 5 8Z" />
      <path d="M0 13C0 11.8954 0.895431 11 2 11H4C5.10457 11 6 11.8954 6 13V16H0V13Z" />
      <path d="M13 12.5C14.1046 12.5 15 11.6046 15 10.5C15 9.39543 14.1046 8.5 13 8.5C11.8954 8.5 11 9.39543 11 10.5C11 11.6046 11.8954 12.5 13 12.5Z" />
      <path d="M10 15.5C10 14.3954 10.8954 13.5 12 13.5H14C15.1046 13.5 16 14.3954 16 15.5V16H10V15.5Z" />
    </svg>
  );
};
